import { actionSet } from './utils'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from './spinner'

import {
  LIST_STORES_SUCCESS,
  LIST_STORES_ERROR,
  LIST_SECTION_BLOCK_SUCCESS,
  LIST_SECTION_BLOCK_ERROR,
  SAVE_SECTION_BLOCK_SUCCESS,
  SAVE_SECTION_BLOCK_ERROR,
  DELETE_SECTION_BLOCK_SUCCESS,
  DELETE_SECTION_BLOCK_ERROR,
  CLEAR_SUCCESS_MESSAGE,
} from 'actionTypes'

export const listStores = (token) => (dispatch) =>
  new Api(token, dispatch).post(API_URL.BRANCHES).then(
    (response) => dispatch(actionSet(LIST_STORES_SUCCESS, response.data)),
    (error) => dispatch(actionSet(LIST_STORES_ERROR, error))
  )

export const listSectionBlock =
  (token, params, page = 1, orderBy = 'sectionId ASC') =>
  (dispatch) =>
    new Api(token, dispatch)
      .post(`${API_URL.LIST_SECTION_BLOCK_V2}?size=10&page=${page}`, {
        ...params,
        orderBy,
      })
      .then(dispatch(showSpinner()))
      .then(
        (response) =>
          dispatch(actionSet(LIST_SECTION_BLOCK_SUCCESS, response.data)),
        (error) => dispatch(actionSet(LIST_SECTION_BLOCK_ERROR, error))
      )
      .finally(() => dispatch(hideSpinner()))

export const saveSectionBlock = (token, params) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.SAVE_SECTION_BLOCK, params)
    .then(dispatch(showSpinner()))
    .then(
      () => dispatch(actionSet(SAVE_SECTION_BLOCK_SUCCESS)),
      (error) => dispatch(actionSet(SAVE_SECTION_BLOCK_ERROR, error))
    )
    .finally(() => dispatch(hideSpinner()))

export const deleteSectionBlock = (token, params) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.DELETE_SECTION_BLOCK, params)
    .then(dispatch(showSpinner()))
    .then(
      () => dispatch(actionSet(DELETE_SECTION_BLOCK_SUCCESS)),
      (error) => dispatch(actionSet(DELETE_SECTION_BLOCK_ERROR, error))
    )
    .finally(() => dispatch(hideSpinner()))

export const clearSuccessMessage = () => (dispatch) =>
  dispatch(actionSet(CLEAR_SUCCESS_MESSAGE))
